import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { UpdateUserName } from '../editUser/updateUserName';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/users/userDetailsHeader.css';

const UserDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/utilisateurs');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const userDetailsData = useSelector((state) => state.UserDetailsData);

    const hasMachineUpdatePermission = useHasPermission('user_update');
    const hasMachineDeletePermission = useHasPermission('user_delete');

    const [errMsg, setErrMsg] = useState('');
    const [modifyName, setModifyName] = useState(false);
    const [deleteUser, setDeleteUser] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleDeleteUser = async () => {
        try {
            const response = await axios.delete(`user/${userDetailsData?.id}`);
            if (response.status === 200 || response.status === 201) {
                setDeleteUser(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.message || "Erreur lors de la suppression de l'utilisateur");
            console.error(error, 'Error deleting user');
            CustomErrorLogger(error, 'Error deleting user');
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = goBack;

    return (
        <Box className="UserDetailsHeader_mainBox">
            <Box className="UserDetailsHeader_firstPart">
                <Iconify className='UserDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="UserDetailsHeader_title">{userDetailsData?.first_name} {userDetailsData?.last_name}</Typography>
                {hasMachineUpdatePermission && <Iconify className='UserDetailsHeader_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyName(true)} />}
                {userDetailsData?.role?.name}
            </Box>
            <Box className="UserDetailsHeader_secondPart">
                {isDesktop && hasMachineDeletePermission &&
                    <Box className="UserDetailsHeader_action_box" onClick={() => setDeleteUser(true)}>
                        <Iconify className='UserDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                        <Typography className="UserDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='UserDetailsHeader_dots_icon'
                    icon={"vaadin:ellipsis-dots-v"}
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasMachineDeletePermission &&
                        <MenuItem className='UserDetailsHeader_menuItem' onClick={() => setDeleteUser(true)}>
                            <Iconify className='UserDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                            <Typography className="UserDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {modifyName &&
                <UpdateUserName
                    modifyName={modifyName}
                    setModifyName={setModifyName}
                />
            }
            {deleteUser &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteUser}
                    setOpenDelete={setDeleteUser}
                    handleDelete={handleDeleteUser}
                    title='Êtes-vous sûr de vouloir supprimer cet utilisateur ?'
                />
            }
        </Box>
    );
}

export default UserDetailsHeader;